package com.shadowings.gero.data.repository

import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.ab01
import gero.composeapp.generated.resources.ab02
import gero.composeapp.generated.resources.ab03
import gero.composeapp.generated.resources.ab05
import gero.composeapp.generated.resources.ab06
import gero.composeapp.generated.resources.ab08
import gero.composeapp.generated.resources.ab14
import gero.composeapp.generated.resources.ab15
import gero.composeapp.generated.resources.ab18
import gero.composeapp.generated.resources.ab20
import gero.composeapp.generated.resources.ab22
import gero.composeapp.generated.resources.ab23
import gero.composeapp.generated.resources.ab24
import gero.composeapp.generated.resources.ab27
import gero.composeapp.generated.resources.ab29
import gero.composeapp.generated.resources.acqua
import gero.composeapp.generated.resources.amenamhat
import gero.composeapp.generated.resources.inpu
import gero.composeapp.generated.resources.iten
import gero.composeapp.generated.resources.mentuhotep
import gero.composeapp.generated.resources.miit
import gero.composeapp.generated.resources.neferhotep
import gero.composeapp.generated.resources.ptah
import gero.composeapp.generated.resources.ramses
import gero.composeapp.generated.resources.re_basso
import gero.composeapp.generated.resources.roast
import gero.composeapp.generated.resources.roast_reading
import gero.composeapp.generated.resources.scribe
import gero.composeapp.generated.resources.tale_12_24
import gero.composeapp.generated.resources.ri00182
import gero.composeapp.generated.resources.ri00200
import gero.composeapp.generated.resources.tale_1_12
import gero.composeapp.generated.resources.tale_24_37
import gero.composeapp.generated.resources.tale_37_51
import gero.composeapp.generated.resources.tutankhamon
import gero.composeapp.generated.resources.tutankhamon2
import org.jetbrains.compose.resources.DrawableResource

// Attribution of a third-party photo or drawing, shown in the fullscreen image popup and in the profile credits.
data class ImageCredit(
    val label: String,
    val credit: String,
    val resources: List<DrawableResource>,
)

// Single source of truth for image attributions: add an entry here whenever a new photo is added.
// Images not listed here (cielo, osiride) still need a verified source.
object ImageCredits {

    val all: List<ImageCredit> = listOf(
        ImageCredit(
            label = "Ptah",
            credit = "Ochmann-HH, Wikimedia Commons, CC BY 2.5 (cropped and annotated)",
            resources = listOf(Res.drawable.ptah)
        ),
        ImageCredit(
            label = "Inpu",
            credit = "Olaf Tausch, Wikimedia Commons, CC BY 3.0 (cropped and annotated)",
            resources = listOf(Res.drawable.inpu)
        ),
        ImageCredit(
            label = "Tutankhamun (chest lid)",
            credit = "Jl FilpoC, Wikimedia Commons, CC BY-SA 4.0 (cropped)",
            resources = listOf(Res.drawable.tutankhamon)
        ),
        ImageCredit(
            label = "Tutankhamun (vase)",
            credit = "Siren-Com, Wikimedia Commons, CC BY-SA 4.0 (cropped)",
            resources = listOf(Res.drawable.tutankhamon2)
        ),
        ImageCredit(
            label = "Neferhotep",
            credit = "Los Angeles County Museum of Art (M.86.313.9), public domain",
            resources = listOf(Res.drawable.neferhotep)
        ),
        ImageCredit(
            label = "Amenemhat",
            credit = "Osama Shukir Muhammed Amin, Wikimedia Commons, CC BY-SA 4.0 (cropped)",
            resources = listOf(Res.drawable.amenamhat)
        ),
        ImageCredit(
            label = "Abydos King List (cartouches 1–29)",
            credit = "Olaf Tausch, derivative work by JMCC1, Wikimedia Commons, CC BY 3.0",
            resources = listOf(
                Res.drawable.ab01, Res.drawable.ab02, Res.drawable.ab03, Res.drawable.ab05, Res.drawable.ab06,
                Res.drawable.ab08, Res.drawable.ab14, Res.drawable.ab15, Res.drawable.ab18, Res.drawable.ab20,
                Res.drawable.ab22, Res.drawable.ab23, Res.drawable.ab24, Res.drawable.ab27, Res.drawable.ab29
            )
        ),
        ImageCredit(
            label = "Menkaure",
            credit = "Prof. Mortel, Wikimedia Commons, CC BY 2.0 (Egyptian Museum, Cairo)",
            resources = listOf(Res.drawable.ri00182)
        ),
        ImageCredit(
            label = "Intef",
            credit = "Osama Shukir Muhammed Amin FRCP(Glasg), Wikimedia Commons, CC BY-SA 4.0 (Petrie Museum of Egyptian Archaeology, UCL)",
            resources = listOf(Res.drawable.ri00200)
        ),
        ImageCredit(
            label = "Iten",
            credit = "The Metropolitan Museum of Art, photo by Anna-Marie Kellen (CC0)",
            resources = listOf(Res.drawable.iten)
        ),
        ImageCredit(
            label = "Mentuhotep",
            credit = "The Metropolitan Museum of Art (22.3.78, CC0)",
            resources = listOf(Res.drawable.mentuhotep)
        ),
        ImageCredit(
            label = "Miit",
            credit = "Jon Bodsworth (Egypt Archive), Wikimedia Commons, copyrighted free use (annotated)",
            resources = listOf(Res.drawable.miit)
        ),
        ImageCredit(
            label = "Seal ring of Iahmes (Louvre N 2082)",
            credit = "Rama, Wikimedia Commons, CC BY-SA 2.0 fr",
            resources = listOf(Res.drawable.scribe)
        ),
        ImageCredit(
            label = "Temple of Kom Ombo",
            credit = "Jerome Bon, Wikimedia Commons, CC BY 2.0 (annotated)",
            resources = listOf(Res.drawable.acqua)
        ),
        ImageCredit(
            label = "Year 16 border stela of Senusret III (Berlin)",
            credit = "Magnus Manske, derivative work by JMCC1, Wikimedia Commons, CC BY-SA 3.0 (annotated)",
            resources = listOf(Res.drawable.re_basso)
        ),
        ImageCredit(
            label = "Tomb of Ukhhotep at Meir",
            credit = "A. M. Blackman, The Rock Tombs of Meir III (1915), pl. XXIII, public domain (annotated)",
            resources = listOf(Res.drawable.roast, Res.drawable.roast_reading)
        ),
        ImageCredit(
            label = "The Shipwrecked Sailor (papyrus Hermitage 1115)",
            credit = "W. Golenischeff, Les papyrus hiératiques No. 1115, 1116 A et 1116 B de l'Ermitage Impérial (1913), public domain",
            resources = listOf(Res.drawable.tale_1_12, Res.drawable.tale_12_24, Res.drawable.tale_24_37, Res.drawable.tale_37_51)
        ),
        ImageCredit(
            label = "Ramesses II storming Dapur",
            credit = "German chromolithograph (1879), Wikimedia Commons, public domain (cropped and annotated)",
            resources = listOf(Res.drawable.ramses)
        ),
    )

    fun forResource(resource: DrawableResource): String? =
        all.firstOrNull { resource in it.resources }?.credit
}
